<script lang="ts">
	import { ArrowForward } from "luxedo-icons"
	import { Responsive } from "../../../../modules/responsive/src/Responsive.svelte"
	import type { Step } from "./types"
	import InstructionStep from "./InstructionStep.svelte"

	interface Props {
		onStepClick?: (stepNumber: number) => void
		index?: number
		steps: {
			[index: number]: Step
		}
	}

	let { onStepClick = undefined, index = 0, steps }: Props = $props()
	let isMobile = $derived(Responsive.isMobile)
</script>

<div class="instruction-steps {onStepClick ? 'clickable' : ''}" class:isMobile>
	{#each Object.entries(steps) as [i, step]}
		<InstructionStep
			{step}
			active={index === Number(i)}
			onclick={onStepClick ? () => onStepClick(Number(i)) : null}
			stepNumber={Number(i) + 1}
		/>
	{/each}
</div>

<style>
	.instruction-steps {
		display: flex;
		flex-direction: column;
	}

	.instruction-steps.clickable :global(.step) {
		cursor: pointer;
	}
</style>
